export enum ROUTEPATHS {
    CLIENT = '/client'
}